<template>
    <v-dialog v-model="modal" max-width="650">
        <template #activator="{ on }">
            <v-btn v-on="on" outlined>
                <v-icon left>mdi-cash-multiple</v-icon>
                Payout List
            </v-btn>
        </template>
        <v-card :loading="loading" :disabled="loading">
            <v-card-title>Payout</v-card-title>
            <v-card-text v-if="list">
                <v-tabs v-model="tab">
                    <v-tabs-slider color="primary"></v-tabs-slider>
                    <v-tab v-if="list.deposit && list.deposit.length > 0">
                        Deposit
                    </v-tab>
                    <v-tab v-if="list.payouts && list.payouts.length > 0">
                        Payout
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item v-if="list.deposit && list.deposit.length > 0">
                        <v-data-table
                            :items="list.deposit"
                            :headers="depositHeaders"
                        >
                            <template #[`item.updated_at`]="{item}">
                                {{ item.updated_at | formatDate }}
                            </template>
                            <template #[`item.amount`]="{item}">
                                {{ item.amount | currency(order.currency.currency) }}
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item v-if="list.payouts &&list.payouts.length > 0">
                        <v-data-table
                            :items="list.payouts"
                            :headers="payoutHeaders"
                        >
                            <template #[`item.updated_at`]="{item}">
                                {{ item.updated_at | formatDate }}
                            </template>

                            <template #[`item.amount`]="{item}">
                                {{ item.amount | currency(order.currency.currency) }}
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="modal=false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';

export default{
    name: "PayoutList",
    data: () => ({
        tab:null,
        modal: false,
        loading:false,
        list: null,
        depositHeaders: [
            {text:'Date', value:'updated_at'},
            {text:'Amount', value:'amount'},
            {text:'Comment', value:'comment'},
            {text:'Type', value:'typeId'},
            {text:'User', value:'user.displayName'}
        ],
        payoutHeaders: [
            {text:'Date', value:'updated_at'},
            {text:'Amount', value:'amount'},
            {text:'Comment', value:'comment'},
            {text:'Type', value:'typeId'}
        ]
    }),
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    filters:{
        formatDate (value) {
            if (!value) return '';
            return moment(value).format('DD/MM/YYYY, HH:mm:ss');
        }
    },
    watch: {
        modal : function (val)  {
            if(val === true){
                this.loadPayoutList();
            }
        }
    },
    methods: {
        ...mapActions("orders", ["getPayouts"]),
        loadPayoutList(){
            this.loading=true
            this.getPayouts(this.order.id)
            .then((data)=>{
                this.loading=false
                this.list = data
            })
        }
    }
}
</script>

